import React from 'react';
import clsx from 'clsx';
import * as Styled from './AScrimGradient.styles';
import { AScrimGradientProps, AScrimGradientDirection } from './AScrimGradient.types';

const COMPONENT_NAME = 'a-web-ui-kit-AScrimGradient';
const TEST_ID = 'web-ui-kit-AScrimGradient';

export const AScrimGradient: React.FC<AScrimGradientProps> = ({
  direction = AScrimGradientDirection.BottomToTop,
  className,
  ...rest
}) => {
  const directionClassMap = {
    [AScrimGradientDirection.BottomToTop]: 'bottom-to-top',
    [AScrimGradientDirection.TopToBottom]: 'top-to-bottom',
    [AScrimGradientDirection.LeftToRight]: 'left-to-right',
  };

  const mergedClassName = clsx(className, directionClassMap[direction]);

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={mergedClassName}
      {...rest}
    />
  );
};